import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
	ModalFooter,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

const EditKilogramsReceivedForm = ({
	dataGuide,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
	handlerUpdateGuide
}) => {
	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: false,
		initialValues: {
			kilograms_to_receive: (dataGuide?.kilograms_to_receive ? dataGuide.kilograms_to_receive : dataGuide.kilograms_total) || ''
		},
		validationSchema: Yup.object({
			kilograms_to_receive: Yup
				.number()
				.required('')
				.test(
					'Kilograms a recepcionar insuficientes',
					`ERROR: No hay suficientes kilogramos disponibles (${dataGuide.kilograms_total}kg disponibles).`,
					(value) => value <= dataGuide.kilograms_total
				)
		}),
		onSubmit: (values) => {
			handlerUpdateGuide({ ...dataGuide, kilograms_to_receive: values.kilograms_to_receive });
			handleToggleModal();
		},
	});


	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody>
				<TabContent activeTab={'1'}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={12}>
								<Label for='kilograms_to_receive' className='form-label'>
									Kilogramos a recepcionar
								</Label>
								<Input
									name='kilograms_to_receive'
									id='kilograms_to_receive'
									className='form-control'
									placeholder='Ingrese el número de kilogramos'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.kilograms_to_receive || ''}
									invalid={
										validation.touched.kilograms_to_receive &&
											validation.errors.kilograms_to_receive
											? true
											: false
									}
								/>
								{
									validation.touched.kilograms_to_receive &&
										validation.errors.kilograms_to_receive ? (
										<FormFeedback type='invalid'>
											{validation.errors.kilograms_to_receive}
										</FormFeedback>
									) : null
								}
							</Col>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<ModalFooter>
				<div className='hstack gap-2 justify-content-end'>
					<Button type='button' onClick={() => { handleToggleModal(); }} className='btn-danger btn-label'><i className="icon-x label-icon"></i> Cancelar</Button>
					<button type='submit' className='btn btn-label btn-primary'><i className='ri-save-3-line label-icon'></i> Guardar</button>
				</div>
			</ModalFooter>
		</Form>
	);
};

export default EditKilogramsReceivedForm;